import {
  faDownload,
  faEye,
  faMagnifyingGlass,
  faPlus,
  faStar,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AgGridReact } from 'ag-grid-react'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import CreateApplication from './CreateApplication'
import { useDispatch } from 'react-redux'
import { setFormSubmitted } from 'store/Recruitment/actions'
import { getJobApplications } from 'store/Recruitment/actions'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux'
import { clientBaseUrl } from 'utils/AxiosInstance'
import { deleteApplication } from 'store/Recruitment/actions'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { setApplication } from 'store/Recruitment/actions'
import { getSystemSetup } from 'store/Recruitment/actions'

function Applications() {
  const dispatch = useDispatch()
  const [showModal, setShowModal] = useState(false)
  const location = useLocation()
  const history = useHistory()

  const { jobApplications, currentSystemSetupRows: jobStages } = useSelector(
    (store) => store.recruitment
  )

  useEffect(() => {
    dispatch(getSystemSetup(null, 'job_stage'))
  }, [dispatch])

  const columns = [
    {
      headerName: 'Name',
      field: 'name',
      sortable: true,
      unSortIcon: true,
    },
    {
      headerName: 'Stage',
      field: 'job_stage',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) => (
        <span>
          {jobStages?.find((stage) => stage?.id === params?.value)?.name ??
            'Applied'}
        </span>
      ),
    },
    {
      headerName: 'CV/Resume',
      field: 'cv_resume',
      cellRenderer: (params) => (
        <>
          {params.data.resume ? (
            <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
              <FontAwesomeIcon
                size='lg'
                icon={faDownload}
                title='Download'
                role='button'
                className='text-success'
                onClick={() => {
                  const url = clientBaseUrl()
                  const resumeUrl = encodeURIComponent(params.data.resume)
                  const proxyUrl = `${url}/recruitment/proxy-resume?url=${resumeUrl}`

                  const link = document.createElement('a')
                  link.href = proxyUrl
                  link.setAttribute('download', '')
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }}
              />
              <FontAwesomeIcon
                size='lg'
                icon={faMagnifyingGlass}
                title='View'
                role='button'
                className='text-info'
                onClick={() => {
                  window.open(params.data.resume, '_blank')
                }}
              />
            </div>
          ) : (
            '-'
          )}
        </>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Rating',
      field: 'rating',
      sortable: true,
      unSortIcon: true,
      cellRenderer: ({ value }) => {
        const rating = value ?? 0

        return (
          <div className='d-flex' style={{ gap: '2px' }}>
            {[...Array(5)].map((_, i) => (
              <FontAwesomeIcon
                key={i}
                icon={faStar}
                className={i < rating ? 'text-warning' : 'text-dark'}
              />
            ))}
          </div>
        )
      },
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Created At',
      field: 'created_at',
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
    },
    {
      headerName: 'Action',
      field: 'action',
      cellRenderer: (params) => (
        <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
          <FontAwesomeIcon
            size='lg'
            icon={faEye}
            title='View'
            role='button'
            className='text-warning'
            onClick={() => {
              dispatch(setApplication(params.data))
              history.push(
                `/job/application/details?application=${params.data.id}`
              )
            }}
          />
          <FontAwesomeIcon
            size='lg'
            icon={faTrash}
            title='Delete'
            role='button'
            className='text-danger'
            onClick={() =>
              dispatch(
                setAreYouSureModalData({
                  show: true,
                  customFn: () =>
                    dispatch(
                      deleteApplication(
                        params.data.id,
                        location?.search?.split('=')?.at(1)
                      )
                    ),
                })
              )
            }
          />
        </div>
      ),
      flex: 1,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ]

  const defaultColDef = {
    sortable: true,
    unSortIcon: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 100,
    resizable: true,
  }

  useEffect(() => {
    if (!showModal) {
      dispatch(setFormSubmitted(false))
    }
  }, [dispatch, showModal])

  useEffect(() => {
    dispatch(getJobApplications(location?.search?.split('=')?.at(1)))
  }, [dispatch, location?.search])

  return (
    <Card>
      <CardHeader className='title d-flex justify-content-between'>
        Manage Job Applications
        <Card
          style={{ marginBottom: 0 }}
          onClick={() => setShowModal(true)}
          className={`bg-info text-white plus-button`}
        >
          <FontAwesomeIcon icon={faPlus} className='' />
        </Card>
      </CardHeader>
      <CardBody>
        <div
          className='ag-theme-alpine'
          style={{ height: '600px', width: '100%' }}
        >
          <AgGridReact
            columnDefs={columns}
            rowData={jobApplications}
            defaultColDef={defaultColDef}
          />
        </div>
      </CardBody>
      {showModal && (
        <CreateApplication showModal={showModal} setShowModal={setShowModal} />
      )}
    </Card>
  )
}

export default Applications
